import { render, staticRenderFns } from "./ContentFilter.vue?vue&type=template&id=11280035&"
import script from "./ContentFilter.vue?vue&type=script&lang=js&"
export * from "./ContentFilter.vue?vue&type=script&lang=js&"
import style0 from "./ContentFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports